import type { Vector2 } from '../match/Vector2';

export type MovementState =
  | 'HOLDING_SHAPE'
  | 'SUPPORTING_ATTACK'
  | 'PRESSING'
  | 'MARKING'
  | 'TRACKING_RUN'
  | 'RECOVERING'
  | 'MAKING_RUN'
  | 'CARRYING_BALL'
  | 'CHASING_LOOSE_BALL'
  | 'GOALKEEPER_POSITIONING';

export type PlayerIntentReason =
  | 'KEEP_SHAPE'
  | 'RETURN_TO_SHAPE'
  | 'RECOVER_POSITION'
  | 'RETURN_ONSIDE'
  | 'SUPPORT_POSSESSION'
  | 'MIDFIELD_ARRIVAL'
  | 'RECYCLE_ATTACK'
  | 'ATTACK_SPACE'
  | 'PRESS_BALL'
  | 'COVER_GOAL'
  | 'MARK_THREAT'
  | 'CHASE_LOOSE_BALL'
  | 'RECEIVE_PASS'
  | 'CARRY_BALL'
  | 'DEFEND_SHOT';

/** Tactical purpose and its spatial consequence, independent from locomotion. */
export interface PlayerIntent {
  movementState: MovementState;
  reason: PlayerIntentReason;
  idealTarget: Vector2;
  reachableTarget: Vector2;
  createdAt: number;
  expiresAt?: number;
  markingTargetId?: string;
}

export interface PlayerIntentProposal {
  movementState: MovementState;
  reason: PlayerIntentReason;
  idealTarget: Vector2;
  durationSeconds?: number;
  markingTargetId?: string;
  bypassAnchor?: boolean;
}

export const isEmergencyIntent = (reason: PlayerIntentReason): boolean => (
  reason === 'CHASE_LOOSE_BALL'
  || reason === 'RECEIVE_PASS'
  || reason === 'CARRY_BALL'
  || reason === 'DEFEND_SHOT'
);

export const isShapeIntent = (reason: PlayerIntentReason): boolean => (
  reason === 'KEEP_SHAPE' || reason === 'RETURN_TO_SHAPE'
);
